import React from 'react';
import './ActionButton.css';

function ActionButton(props) {

  const { buttonText, buttonType, functionOnClick, disabled } = props;

  const colorType = {
    action: '#F7A29E',
    cancel: '#F81005',
  }

  return (
    <button
      className="button-action"
      onClick={functionOnClick}
      disabled={disabled}
      style={{backgroundColor: colorType[buttonType]}}
    >
      { buttonText }
    </button>
  )
}

export default ActionButton